module.exports = _.extend(
    require('./sprayGuy'),
    require('./torchGuy'),
    require('./laserGuy'),
    require('./blob'),
    {
        paintersBg: {
            texture: '/img/partials/blobs-treadmill/painters-bg.jpg',
            scale: {
                x: '100%',
            },
        },
    },
);



// WEBPACK FOOTER //
// ./js/objects/partials/blobsTreadmill.js